<template>
    <div class="hover:bg-red-800 bg-transparent transition p-3 cursor-pointer">
        <img class="object-contain h-[38px] w-[80px] lg:h-auto lg:w-[150px] mx-auto" :src="track.layout" loading="lazy" :alt="track.name">
        <div class="uppercase font-bold text-center">{{ track.name }}</div>
    </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
    };
  },
  components: {
  },
  props: {
    track: {
        required: true,
        type: Object
    },
  },
};
</script>